import { applyFilter } from "std/util";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import type { ApiRelatorioParams } from "./types/ApiRelatorioParams";

type RelatorioStore = {
	isRelatorioRequisitado: boolean;
	isImpressaoRequisitado: boolean;

	filter: Optional<ApiRelatorioParams>;

	applyFilter: (filter: Optional<ApiRelatorioParams>) => void;
	limparFiltros: () => void;
};

export const useRelatorioStore = create(
	persist(
		devtools<RelatorioStore>(
			(set, get) => ({
				isRelatorioRequisitado: false,
				isImpressaoRequisitado: false,

				filter: undefined,

				applyFilter: (filter) => {
					applyFilter(filter, get, set);
				},

				limparFiltros: () => {
					set({ filter: undefined });
				},
			}),
			{ name: "relatorio" },
		),
		{
			name: "relatorio",
			partialize: () => undefined,
		},
	),
);
